export const UPDATE_DATAOPS = 'UPDATE_DATAOPS';
export const UPDATE_DATAOPS_EVENT = 'UPDATE_DATAOPS_EVENT';